import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoggerService, OccEndpointsService, normalizeHttpError } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LufcCustomerRegisterAdapter } from './lufc-customer-register.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccLufcCustomerRegisterAdapter implements LufcCustomerRegisterAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  addLufcId(lufcId: string): Observable<string> {
    const url: string = this.occEndpoints.buildUrl('lufcId', { urlParams: { userId: 'current' } });

    const httpParams: HttpParams = new HttpParams().set('lufcId', lufcId);

    return this.http.post<string>(url, httpParams).pipe(catchError((error) => throwError(error)));
  }

  getLufcId(): Observable<string> {
    const url = this.occEndpoints.buildUrl('lufcId', { urlParams: { userId: 'current' } });
    return this.http.get<string>(url).pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
